import { Row } from "antd";
import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import About from "../assets/images/About Me.svg";
import Contact from "../assets/images/Contact Me.svg";
import Home from "../assets/images/Home.svg";
import stateWrapper from "../containers/provider";
import Svgs from "../svgs/index";

const NavItem = ({ href, onPress = () => {}, ...props }) => {
  const location = useLocation();

  useEffect(() => {
    if (window) {
      props?.masterStore?.setSelectedBar(location?.pathname);
    }
  }, [location?.pathname]);

  const Image = () => {
    return <Svgs.zigzaga fill="#ffad0d" width={100} height={70} />;
  };

  const handleOnClick = () => {
    props?.masterStore?.setSelectedBar(href);
    onPress();
  };

  return (
    <>
      <Row style={{ margin: 20, marginTop: 0, marginRight: 30 }}>
        <Link to={href} onClick={handleOnClick}>
          {href == "/about" && (
            <img
              src={About}
              style={{
                width: 70,
                height: 30,
                fontFamily: "Arial Rounded MT Bold",
              }}
            />
          )}
          {href == "/contact" && (
            <img
              src={Contact}
              style={{
                width: 70,
                height: 30,
                fontFamily: "Arial Rounded MT Bold",
              }}
            />
          )}
          {href == "/home" && (
            <img
              src={Home}
              style={{
                width: 70,
                height: 30,
                fontFamily: "Arial Rounded MT Bold",
              }}
            />
          )}
        </Link>
      </Row>
      <Row style={{ position: "relative", top: -40 }}>
        {props?.masterStore?.state?.selectedRoute == href ? <Image /> : null}
      </Row>
    </>
  );
};

export default stateWrapper(NavItem);
